export function imageFunction(imageUrls) {
  if (!Array.isArray(imageUrls)) return [];

  return imageUrls.map((url) =>
    url.includes("{size}") ? url.replace("{size}", "1024x768") : url
  );
}

export function formatDate(timestamp) {
  const date = new Date(timestamp);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${year}-${month}-${day}`;
}

export function roundPrice(price) {
  return Math.round(price);
}

export function formatPrice(price){
  return price ? (Math.round(price * 100) / 100).toFixed(2) : "0.00";
};

